export default {
    // Header Section
    "discover_your": "अपने",
    "lal_kitab": "लाल किताब",
    "ancient_remedial_wisdom": "प्राचीन उपचारात्मक ज्ञान",
    "lal_kitab_description": "व्यक्तिगत लाल किताब विश्लेषण के साथ प्राचीन ज्ञान की दुनिया में कदम रखें। छुपे हुए कार्मिक पैटर्न को प्रकट करें, जीवन के रहस्यों को उजागर करें, और चुनौतियों को सफलता, सामंजस्य और समृद्धि के अवसरों में बदलने के लिए सरल लेकिन शक्तिशाली उपाय प्राप्त करें।",

    "lal_kitab_title": "लाल किताब के साथ",
    "craft_your_destiny": "अपना भाग्य बनाएं",

    // Service Information
    "enter_details_for_lal_kitab": "लाल किताब विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_lal_kitab_analysis": "संपूर्ण लाल किताब विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_lal_kitab_analysis_note": "व्यावहारिक उपचार और कार्मिक मार्गदर्शन के साथ विस्तृत लाल किताब चार्ट विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_lal_kitab_influence": "आपका नाम लाल किताब में कार्मिक पैटर्न और उपचारात्मक प्रभावशीलता को प्रभावित करता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_lal_kitab_chart": "सटीक लाल किताब चार्ट और ग्रहीय विश्लेषण बनाने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_lal_kitab_houses": "लाल किताब प्रणाली में सटीक भाव स्थिति के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_lal_kitab_analysis": "स्थान ग्रहीय स्थितियों और लाल किताब चार्ट गणना को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका लाल किताब विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Lal Kitab Features
    "lal_kitab_chart_analysis": "लाल किताब चार्ट विश्लेषण",
    "planetary_positions_lal_kitab": "लाल किताब में ग्रहीय स्थितियां",
    "practical_remedies_solutions": "व्यावहारिक उपचार और समाधान",
    "karmic_debts_analysis": "कार्मिक ऋण विश्लेषण",
    "life_predictions_guidance": "जीवन भविष्यवाणी और मार्गदर्शन",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके लाल किताब विश्लेषण में क्या शामिल है",
    "complete_lal_kitab_chart": "संपूर्ण लाल किताब चार्ट",
    "practical_remedial_measures": "व्यावहारिक उपचारात्मक उपाय",
    "karmic_analysis_guidance": "कार्मिक विश्लेषण और मार्गदर्शन",
    "life_predictions_insights": "जीवन भविष्यवाणी और अंतर्दृष्टि",

    // Actions & Buttons
    "pay_and_get_lal_kitab_analysis": "मेरा लाल किताब विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "lal_kitab_analysis_processing": "आपका व्यापक लाल किताब विश्लेषण हमारे विशेषज्ञ लाल किताब ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको व्यावहारिक उपचार और कार्मिक अंतर्दृष्टि के साथ विस्तृत चार्ट विश्लेषण प्राप्त होगा।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_24_hours_delivery_note": "आपका विस्तृत लाल किताब विश्लेषण 24 घंटों के भीतर तैयार हो जाएगा",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका लाल किताब विश्लेषण पैकेज",
    "detailed_lal_kitab_report": "विस्तृत लाल किताब रिपोर्ट (पीडीएफ)",
    "lal_kitab_chart_analysis": "लाल किताब चार्ट विश्लेषण",
    "practical_remedies_list": "व्यावहारिक उपचार सूची",
    "karmic_debts_solutions": "कार्मिक ऋण और समाधान",
    "life_guidance_predictions": "जीवन मार्गदर्शन और भविष्यवाणी",

    // Visual Content
    "sample_lal_kitab_analysis": "नमूना लाल किताब विश्लेषण",
    "lal_kitab_house_analysis": "लाल किताब भाव विश्लेषण",
    "sample_lal_kitab_reading": "व्यावहारिक उपचारात्मक समाधानों के साथ मजबूत ग्रहीय स्थितियां",
    "sample_lal_kitab_preview": "उपचारात्मक मार्गदर्शन के साथ आपके व्यक्तिगत लाल किताब विश्लेषण का पूर्वावलोकन",
    "lal_kitab_houses": "लाल किताब भाव",

    // House Types
    "self": "स्वयं",
    "wealth": "धन",
    "siblings": "भाई-बहन",
    "mother": "माता",
    "children": "संतान",
    "enemies": "शत्रु",
    "spouse": "जीवनसाथी",
    "longevity": "आयु",
    "father": "पिता",
    "career": "करियर",
    "gains": "लाभ",
    "expenses": "व्यय",

    // Status & Processing
    "your_lal_kitab_analysis_status": "आपके लाल किताब विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके लाल किताब चार्ट का विश्लेषण",
    "analysis_processing_message": "हमारे विशेषज्ञ लाल किताब ज्योतिषी व्यावहारिक उपचार और कार्मिक अंतर्दृष्टि के साथ सटीक विश्लेषण प्रदान करने के लिए आपकी जन्म कुंडली का अध्ययन कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_24_hours": "रिपोर्ट 24 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "लाल किताब सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Lal Kitab Specific Elements
    "planetary_debts": "ग्रहीय ऋण",
    "karmic_accounts": "कार्मिक खाते",
    "ancestral_karma": "पूर्वज कर्म",
    "past_life_debts": "पूर्वजन्म ऋण",
    "family_karma": "पारिवारिक कर्म",
    "collective_karma": "सामूहिक कर्म",

    // Planets in Lal Kitab
    "sun_lal_kitab": "लाल किताब में सूर्य",
    "moon_lal_kitab": "लाल किताब में चंद्र",
    "mars_lal_kitab": "लाल किताब में मंगल",
    "mercury_lal_kitab": "लाल किताब में बुध",
    "jupiter_lal_kitab": "लाल किताब में बृहस्पति",
    "venus_lal_kitab": "लाल किताब में शुक्र",
    "saturn_lal_kitab": "लाल किताब में शनि",
    "rahu_lal_kitab": "लाल किताब में राहु",
    "ketu_lal_kitab": "लाल किताब में केतु",

    // Remedial Categories
    "simple_remedies": "सरल घरेलू उपाय",
    "donation_remedies": "दान और धर्म उपाय",
    "feeding_remedies": "भोजन और सेवा उपाय",
    "water_remedies": "जल संबंधी उपाय",
    "clothing_remedies": "वस्त्र और रंग उपाय",
    "behavioral_remedies": "व्यवहार परिवर्तन उपाय",

    // Types of Debts
    "pitra_rin": "पितृ ऋण (पूर्वज ऋण)",
    "matru_rin": "मातृ ऋण (माता का ऋण)",
    "stree_rin": "स्त्री ऋण (पत्नी का ऋण)",
    "bhratru_rin": "भ्रातृ ऋण (भाई का ऋण)",
    "putra_rin": "पुत्र ऋण (पुत्र का ऋण)",
    "guru_rin": "गुरु ऋण (शिक्षक का ऋण)",

    // Lal Kitab Concepts
    "blind_planets": "अंधे ग्रह",
    "lame_planets": "लंगड़े ग्रह",
    "sleeping_planets": "सोते ग्रह",
    "deceased_planets": "मृत ग्रह",
    "enemy_planets": "शत्रु ग्रह",
    "friend_planets": "मित्र ग्रह",

    // House Analysis
    "first_house": "प्रथम भाव - व्यक्तित्व और स्वयं",
    "second_house": "द्वितीय भाव - धन और परिवार",
    "third_house": "तृतीय भाव - भाई-बहन और संवाद",
    "fourth_house": "चतुर्थ भाव - माता और संपत्ति",
    "fifth_house": "पंचम भाव - संतान और शिक्षा",
    "sixth_house": "षष्ठ भाव - शत्रु और स्वास्थ्य",
    "seventh_house": "सप्तम भाव - विवाह और साझेदारी",
    "eighth_house": "अष्टम भाव - आयु और गुप्त विद्या",
    "ninth_house": "नवम भाव - पिता और भाग्य",
    "tenth_house": "दशम भाव - करियर और स्थिति",
    "eleventh_house": "एकादश भाव - लाभ और मित्र",
    "twelfth_house": "द्वादश भाव - व्यय और विदेश",

    // Planetary Strengths
    "strong_planets": "मजबूत ग्रह",
    "weak_planets": "कमजोर ग्रह",
    "malefic_planets": "पाप ग्रह",
    "benefic_planets": "शुभ ग्रह",
    "neutral_planets": "तटस्थ ग्रह",
    "exalted_planets": "उच्च ग्रह",

    // Remedy Types
    "immediate_remedies": "तत्काल प्रभावी उपाय",
    "long_term_remedies": "दीर्घकालिक उपाय",
    "emergency_remedies": "आपातकालीन उपाय",
    "preventive_remedies": "निवारक उपाय",
    "corrective_remedies": "सुधारात्मक उपाय",
    "protective_remedies": "सुरक्षात्मक उपाय",

    // Life Areas Analysis
    "health_analysis": "स्वास्थ्य विश्लेषण",
    "wealth_analysis": "धन विश्लेषण",
    "career_analysis": "करियर विश्लेषण",
    "marriage_analysis": "विवाह विश्लेषण",
    "children_analysis": "संतान विश्लेषण",
    "property_analysis": "संपत्ति विश्लेषण",

    // Timing Analysis
    "favorable_periods": "अनुकूल अवधि",
    "challenging_periods": "चुनौतीपूर्ण अवधि",
    "remedy_timing": "उपाय कार्यान्वयन समय",
    "result_timing": "अपेक्षित परिणाम समय",
    "life_phases": "प्रमुख जीवन चरण",
    "turning_points": "जीवन मोड़",

    // Special Features
    "curse_analysis": "श्राप और नकारात्मक ऊर्जा विश्लेषण",
    "blessing_analysis": "आशीर्वाद और सकारात्मक ऊर्जा",
    "family_tree_karma": "पारिवारिक वृक्ष कर्म विश्लेषण",
    "generational_patterns": "पीढ़ियों के कर्म पैटर्न",
    "soul_purpose": "आत्मा का उद्देश्य और जीवन मिशन",
    "spiritual_evolution": "आध्यात्मिक विकास पथ",

    // Practical Applications
    "daily_remedies": "दैनिक दिनचर्या उपाय",
    "weekly_remedies": "साप्ताहिक पालन",
    "monthly_remedies": "मासिक अभ्यास",
    "annual_remedies": "वार्षिक पालन",
    "special_occasion_remedies": "विशेष अवसर उपाय",
    "festival_remedies": "त्योहार आधारित उपाय",

    // Modern Adaptations
    "urban_remedies": "शहरी जीवन अनुकूलन",
    "office_remedies": "कार्यक्षेत्र उपाय",
    "travel_remedies": "यात्रा और सफर उपाय",
    "technology_remedies": "आधुनिक तकनीक उपाय",
    "social_media_remedies": "डिजिटल युग उपाय",
    "global_living_remedies": "अंतर्राष्ट्रीय जीवन अनुकूलन",

    // Consultation Features
    "expert_consultation": "विशेषज्ञ लाल किताब परामर्श",
    "follow_up_guidance": "अनुवर्ती उपाय मार्गदर्शन",
    "progress_tracking": "उपाय प्रगति ट्रैकिंग",
    "customization": "व्यक्तिगत उपाय अनुकूलन",
    "update_analysis": "अद्यतन विश्लेषण विकल्प",
    "family_analysis": "पारिवारिक चार्ट विश्लेषण",

    // Advanced Concepts
    "paap_planets": "पाप ग्रह",
    "punya_planets": "पुण्य ग्रह",
    "raja_yoga": "लाल किताब में राज योग",
    "dhana_yoga": "धन योग संयोजन",
    "vipreet_raja_yoga": "विपरीत राज योग",
    "neech_bhang_yoga": "नीच भंग योग",

    // Unique Lal Kitab Rules
    "pakka_ghar": "पक्का घर",
    "kachha_ghar": "कच्चा घर",
    "mool_trikona": "लाल किताब में मूल त्रिकोण",
    "own_house": "स्व गृह स्थिति",
    "friendly_house": "मित्र गृह स्थिति",
    "enemy_house": "शत्रु गृह स्थिति"
};
